import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="error-boundary">
          <div className="text-center max-w-md">
            <AlertTriangle className="h-12 w-12 text-amber-400 mx-auto mb-6" />
            <h1 className="text-2xl font-semibold text-foreground mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              Something went wrong
            </h1>
            <p className="text-muted-foreground mb-8 text-sm">
              An unexpected error occurred. Please try refreshing the page.
            </p>
            <div className="flex items-center justify-center gap-3">
              <Button
                onClick={() => window.location.reload()}
                variant="default"
                size="sm"
                data-testid="error-retry-btn"
              >
                <RefreshCw className="h-4 w-4 mr-2" /> Refresh
              </Button>
              <a href="/">
                <Button variant="outline" size="sm" data-testid="error-home-btn">
                  <Home className="h-4 w-4 mr-2" /> Home
                </Button>
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
